import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'

import {
  BatchCollectionMgmtListByCollectionRequest,
  BatchCollectionMgmtListByCollectionRequestToJSON
} from '@/api/models/batch/BatchCollectionMgmtListByCollectionRequest'
import {
  BatchCollectionMgmtListByCollectionPageLoadResult,
  BatchCollectionMgmtListByCollectionPageLoadResultFromJSON
} from '@/api/models/batch/BatchCollectionMgmtListByCollectionPageLoadResult'

export class BatchCollectionMgmtListByCollectionApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchCollectionMgmtListByCollectionPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchCollectionMgmtListByCollectionPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createCollectionMgmtListByCollection(
    request: BatchCollectionMgmtListByCollectionRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/collection-management/list-by-collection`,
      BatchCollectionMgmtListByCollectionRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
